import { Injectable, signal } from '@angular/core';

@Injectable()
export class MapServiceMock {
  ready = signal(false);
  selectedMapItemId = signal<number | undefined>(undefined);
  requestedFocusItemId = signal<number | undefined>(undefined);

  reset() {}
  selectItem() {}
  focusItem() {}
  requestFocusItem() {}
  clearRequestedFocusItem() {}
  focusRequestedItem() {}
}
